module.exports = __webpack_public_path__ + "img/book-blue.27983dbf.svg";